import React from 'react';
import Row from '@amzn/meridian/row';
import Icon from '@amzn/meridian/icon';
import Text from '@amzn/meridian/text';
import { adspIcon, googleIcon, metaIcon, tiktokIcon } from 'src/store/icons';
import imageIcon from '@amzn/meridian-tokens/base/icon/image';

interface PublisherDisplayProps {
  publisher: string;
  spacing?: '100' | '200' | '300' | '400' | '500';
  textType?: 'b100' | 'b200' | 'b300' | 'b400' | 'h100' | 'h200' | 'h300' | 'h400';
  iconOnly?: boolean;
  textOnly?: boolean;
}

function getPublisherIconToken (publisher: string) {
  switch (publisher.toLowerCase()) {
    case 'meta':
      return metaIcon;
    case 'adsp':
      return adspIcon;
    case 'tiktok':
      return tiktokIcon;
    case 'google':
      return googleIcon;
    default:
      return imageIcon;
  }
}

export const PublisherDisplay: React.FC<PublisherDisplayProps> = ({
  publisher,
  spacing = '200',
  textType = 'b300',
  iconOnly = false,
  textOnly = false,
}) => {
  return (
    <Row spacing={spacing}>
      {!textOnly && <Icon tokens={getPublisherIconToken(publisher)} />}
      {!iconOnly && <Text type={textType}>{publisher}</Text>}
    </Row>
  );
};
